import React from 'react';
import QuoteValidationModal from './modals/QuoteValidationModal';
import PlanificationModal from './PlanificationModal';
import ChargementModal from './ChargementModal';
import LivraisonModal from './LivraisonModal';
import FacturationModal from './FacturationModal';
import PaiementModal from './PaiementModal';
import { logger } from '../utils/logger';

/**
 * ModalManager - Orchestrateur central de tous les popups
 * Gère l'ouverture des modals selon l'actionType des notifications
 */
const ModalManager = ({ 
  activeModal, 
  modalData, 
  onClose,
  onSuccess 
}) => {
  if (!activeModal) return null;

  // Map actionType to corresponding modal component
  switch (activeModal) {
    case 'ACCEPTER_REFUSER_DEVIS':
    case 'VALIDER_DEVIS':
      return (
        <QuoteValidationModal
          isOpen={true}
          onClose={onClose}
          operation={modalData}
          onSuccess={onSuccess}
        />
      );
    
    case 'PLANIFIER':
      return (
        <PlanificationModal
          open={true}
          onClose={onClose}
          operation={modalData}
          onSuccess={onSuccess}
        />
      );
    
    case 'CONFIRMER_CHARGEMENT':
      return (
        <ChargementModal
          open={true}
          onClose={onClose}
          operation={modalData}
          onSuccess={onSuccess}
        />
      );
    
    case 'CONFIRMER_LIVRAISON':
      return (
        <LivraisonModal
          open={true}
          onClose={onClose}
          operation={modalData}
          onSuccess={onSuccess}
        />
      );
    
    case 'GENERER_FACTURE':
      return (
        <FacturationModal
          open={true}
          onClose={onClose}
          operation={modalData}
          onSuccess={onSuccess}
        />
      );
    
    case 'CONFIRMER_PAIEMENT':
      return (
        <PaiementModal
          open={true}
          onClose={onClose}
          operation={modalData}
          onSuccess={onSuccess}
        />
      );
    
    case 'NEGOCIER_DEVIS':
      return (
        <QuoteValidationModal
          isOpen={true}
          onClose={onClose}
          operation={modalData}
          onSuccess={onSuccess}
        />
      );
    
    case 'VOIR_DETAILS':
      // Navigate to operation details instead of opening modal
      logger.debug('Navigate to operation details');
      onClose();
      return null;
    
    default:
      console.warn(`Unknown modal type: ${activeModal}`);
      onClose();
      return null;
  }
};

export default ModalManager;
